<template>
  <div class="right">
    <div class="content">
      <div class="title">半年度热销单品统计</div>
      <div id="myCharts" :style="{ width: '90%', height: '90%' }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Right",
  data() {
    return {
      id: 87,
      moneys: [],
      names: [],
      counts: [],
    };
  },
  created() {
    let date = new Date();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    for (let i = 0; i < 5; i++) {
      if (month === 1) {
        month = 13;
        year--;
      }
      month--;
    }
    month = month < 10 ? "0" + month : month;
    let monthString = year + "-" + month;
    this.$axios
      .get(
        `http://www.lcyjfz.com/api/business/orderReport?month=${monthString}&shopid=${this.id}`
      )
      .then((res) => {
        res.data.data.number.sort((a, b) => b.sale_money - a.sale_money);
        let myChart = this.$echart.init(document.getElementById("myCharts"));
        let numberArr = res.data.data.number.slice(0, 15);
        this.moneys = numberArr.map((item) => item.sale_money);
        this.names = numberArr.map((item) => item.goods_name);
        this.counts = numberArr.map((item) => item.count);
        let that = this;
        let option = {
          tooltip: {
            trigger: "axis",
            padding: 15,
            formatter: function (param) {
              let index = param[0].dataIndex; // 获取下标
              let name = that.names[index]; // name
              let count = that.counts[index]; // 数量
              let money = that.moneys[index]; // money
              return `<div>产品名:${name}</div><div>数量:${count}</div><div>销售金额:${money}</div>`;
            },
          },
          legend: {
            data: ["销量"],
            textStyle: {
              fontSize: 16,
              color: "#fff",
            },
          },
          xAxis: {
            type: "value",
            axisLabel: {
              show: true,
              textStyle: {
                color: "white",
              },
            },
          },
          yAxis: {
            type: "category",
            data: this.names,
            axisLabel: {
              show: true,
              textStyle: {
                color: "white",
              },
            },
          },
          grid: {
            left: "20%",
            right: "4%",
            bottom: "10%",
            top: "10%",
          },
          series: [
            {
              name: "销量",
              data: this.moneys,
              type: "bar",
              barWidth: "60%",
              showBackground: true,
              backgroundStyle: {
                color: "rgba(180, 180, 180, 0.2)",
              },
              itemStyle: {
                normal: {
                  color: "rgb(2,127,133)",
                },
              },
            },
          ],
        };
        myChart.setOption(option);
      });
  },
};
</script>

<style lang="less" scoped>
.right {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 999;
  .content {
    width: 90%;
    height: 100%;
    margin: 0 auto;
    background: url("~@/assets/image/框D.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    .title {
      width: 80%;
      margin: 0 auto;
      position: absolute;
      top: -0.25rem;
      padding: 0 1.25rem;
      font-size: 1rem;
      text-align: center;
      left: 0;
      right: 0;
      color: white;
    }
    #myCharts {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
    }
  }
}
</style>